import Mediator from './Mediator';

class Teacher extends Mediator {
  constructor(data) {
    super(data);

    if (data instanceof Mediator) {
      return this;
    }

    this.setVersion('v1', [
      'id', 'tName', 'stArchived', 'stRemark', 'stState', 'tEmail', 'tGender',
      'tGender', 'tPhone', 'taughthours', 'taughttimes', 'profile_photo', 
      'profile_photo_thumbnail_1x', 'profile_photo_thumbnail_2x', 'profile_photo_thumbnail_8x', 'stPhone_parsed'
    ]);

    this.setVersion('v2', [
      'id', 'stName', 'stGender', 'profile_photo', 
      'profile_photo_thumbnail_1x', 'profile_photo_thumbnail_2x', 'profile_photo_thumbnail_8x'
    ]);
    
    this.setVersion('v3', [
      'teacher_id', 'stName', 
    ]);

    this.__schema = {
      id: {
        alias: ['id', 'teacher_id'],
      },
      name: {
        alias: ['name', 'stName', 'tName'],
      },
      gender: {
        alias: ['gender', 'stGender', 'tGender'],
      },
      archived: {
        alias: ['archived', 'stArchived'],
      },
      remark: {
        alias: ['remark', 'stRemark'],
      },
      email: {
        alias: ['email', 'tEmail', 'stEmail'],
      },
      phone: {
        alias: ['tPhone', 'phone', 'stPhone'],
      },
      phoneParsed:{
        alias: ['stPhone_parsed']
      },
      taughtHours: {
        alias: ['taughthours'],
      },
      taughtTimes: {
        alias: ['taughttimes'],
      },
      profilePhoto: {
        alias: ['profile_photo'],
      },
      profilePhotoThumbnail1x: {
        alias: ['photo_thumbnail_1x'],
      },
      profilePhotoThumbnail2x: {
        alias: ['photo_thumbnail_2x'],
      },
      profilePhotoThumbnail8x: {
        alias: ['photo_thumbnail_8x'],
      },
    }

    return this.create();
  }

}

export default Teacher;



// WEBPACK FOOTER //
// ./src/mediators/Teacher.js